var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[_c('RestaurantInfo',{attrs:{"restaurant":_vm.restaurant,"loadMenu":_vm.loadMenu,"forceMenuLoad":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }